export const ALLOWED_CHAT_ORIGINS = new Set([
  "https://missionary-chat.churchofjesuschrist.org",
  "https://missionary-chat-stage.churchofjesuschrist.org",
  "https://missionary-chat-dev.churchofjesuschrist.org",
  "https://missionary-chat-test.churchofjesuschrist.org"
]);

export const parseAllowedChatUrl = (raw) => {
  if (!raw) return null;
  try {
    const url = new URL(raw.startsWith("http") ? raw : `https:${raw}`);
    return ALLOWED_CHAT_ORIGINS.has(url.origin) ? url : null;
  } catch {
    return null;
  }
};
